import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& div': {
      outline: 'none',
    },
    '& a': {
      transition: '0.2s linear',
      '&:focus': {
        outline: 'none',
        backgroundColor: '#2A2E4329',
      }
    },
  },
  
  divtop10: {
    textAlign: 'center',
    display: 'inline-block',
    alignItems: 'center',
    width: '110px',
    height: '90px',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(4),
    marginLeft: theme.spacing(1),
    borderRadius: '10px',
    padding: '10px',
    display: 'flex',
    justifyContent: 'center',
    transition: 'background-color 0.5s',
    backgroundColor: 'transparent',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    '&:hover': {
      backgroundColor: '#c6c6c6',
    },
  },
  h6trunc: {
    maxWidth: '100px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: '3',
    color: 'gray', 
  },
  rowStatus: {
    justifyContent: 'space-between',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(0),
    },
  },
  quickAccessContainer: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      width: '100%',
    },
  },

  topButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'space-around',
      width: '100%',
      marginTop: theme.spacing(1)
    },
  },

  button: {
    marginLeft: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(0),
      width: '100%',
    },
  },

  overrideWrap: {
    flexWrap: 'unset',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    }
  },
  buttontop10: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  contentCenter: {
    alignItems: 'center',
    paddingTop: theme.spacing(2),
  },

  carrossel: {
    position: 'relative',
  },
  buttons: {
    position: 'absolute',
    top: '30%',
    border: 'none',
    backgroundColor: 'transparent',
  },
  slideContainer: {
    margin: '0 2.3%',
    height: '180px',
  },
  slideCard: {
    display: 'flex !important',
    justifyContent: 'center',
    flexDirection: 'column',
    transition: 'transform 0.3s ease-in-out, background-color 0.3s ease-in-out',
      '&:hover': {
        transform: 'scale(1.05)',
      }
  },
  centeredSlide: {
    display: 'flex !important',
    justifyContent: 'center',
  },
  image: {
    width: '95%',
    maxWidth: 200,
    minHeight: 111,
    maxHeight: 115,
    margin: '0 auto',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    border: '1px solid #707070',
    cursor: 'pointer',
    borderRadius: '10px',
    objectFit: 'cover',
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      minHeight: 94,
      maxHeight: 95,
      minWidth: 166
    }
  },
  imageCompany: {
    height: 115,
    maxWidth: 190,
    objectFit: 'contain', 
    backgroundColor: '#f4f4f4', 
    cursor: 'pointer',
    borderRadius: '10px',
    border: '1px solid #707070',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 150,
      height: 90,
      objectFit: 'cover'
    }
  },
  text: {
    padding: '0 10px',
    marginTop: 10,
    textAlign: 'center',
    marginLeft: -10,
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      marginLeft: -15
    }
  },
  title: {
    fontWeight: 'bold',
    fontSize: theme.typography.fontSize * 2,
    lineHeight: '100%',
  },
  highlighted: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  hidden: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  }
}));
